<template>
  <div class="index_warp">
    <div class="cont_box">
      <div class="left_logo" v-if="!titleText">
        <img src="@/assets/m/logo.png" alt="">
      </div>
     <div v-else class="flex">
       <div class="goBack" @click="goBack()"><i class="el-icon-arrow-left"></i></div>
       <p class="title">{{titleText}}</p>
     </div>
      <div class="right_menu">
        <div class="login_state flex" v-if="!titleText">
            <div class="text_login flex" v-if="!userCont" @click="goLogin()">
              <p >登录</p>
              <p>/</p>
              <p >注册</p>
            </div>
            <div class="per_info" v-else >
              <p class="flex" @click="$router.push('/userData/index')">
                <img v-if="user_avater"  :src="user_avater" alt="" />
                <img v-else @click="$router.push('/userData/index')" src="@/assets/per_img.png" alt="" />
                <span style="margin-left:5px;">个人中心</span>
              </p>
            </div>
        </div>
        <p class="img_icon flex" @click="menuState = !menuState">
          <img src="@/assets/m/menu_icon.png" alt="">
          <span>导航</span>
        </p>
        <div class="menu_list" v-if="menuState">
          <ul class="titleMenu">
          <li>
              <router-link :class="$route.path=='/'?'activeMenu':''" to="/"
                >首页</router-link
              >

          </li>
          <li>
            <router-link active-class="activeMenu" to="/course/index"
              >学习平台</router-link
            >
          </li>
          <li>
            <router-link active-class="activeMenu" to="/studio/list"
              >创新工作室</router-link
            >
          </li>
          <li>
            <router-link active-class="activeMenu" to="/achievement/achieveList"
              >创新成果</router-link
            >
          </li>
          <li>
            <router-link active-class="activeMenu" to="/gjrc/list"
              >工匠人才</router-link
            >
          </li>
          <!-- 
          <li>
            <router-link active-class="activeMenu" to="/project/index"
              >创新项目</router-link
            >
          </li>
          <li>
            <router-link active-class="activeMenu" to="/problem/index"
              >疑难攻关</router-link
            >
          </li> -->
          <li>
            <router-link active-class="activeMenu" to="/news_list"
              >新闻中心</router-link
            >
          </li>
          <li>
            <!-- <router-link active-class="activeMenu" to="/skills/index"
              >技能竞赛</router-link
            > -->
            <a href="https://dllmzqx.kjcxchina.com" target="_blank" class="post">助企行</a>
          </li>
          <li v-if="userCont">
            <router-link active-class="activeMenu" to="/userData/index"
              >个人中心</router-link
            >
          </li>
        </ul>
        </div>
        <div class="mask_deep_box"  v-if="menuState"  @click="menuState = false"></div>
      </div>
    </div>
     <Login v-if="mLoginModal.show" :showIndex="showIndex" />
  </div>
</template>
<script>
import Login from "@/components/m/login.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "index",
  data() {
    return {
       showIndex: 1,
      menuState:false,
      userCont:{},
      user_avater:'',//头像
      titleText:''
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapState(["tipModal", "mLoginModal", "userInfo"]),
  },
   watch: {
    $route: {
      handler(newVal) {
        this.menuState = false
        console.log(newVal.meta.title)
        this.titleText = newVal.meta.title
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      },
      immediate: true,
    },
  },
  mounted() {
    console.log(this.$route.path)
    this.userCont = localStorage.getItem('userData')?JSON.parse(localStorage.getItem('userData')):''
    this.user_avater = localStorage.getItem('user_avater')?JSON.parse(localStorage.getItem('user_avater')):''
    console.log(this.userCont)
  },
  methods: {
     ...mapMutations([
      "ShowMLoginModal",
      "CloseMLoginModal",
      "GetUserInfo",
      "ClearUserInfo",
      "ShowTipModal",
    ]), //登录弹窗
     // 登录
    goLogin() {
      // this.showIndex = 1;
      //  this.ShowMLoginModal();
      this.$router.push('/login')
    },
    goBack(){
       this.$router.go(-1)
    },
    // // 注册
    // goRegister() {
     
    // },
  },
};
</script>
<style scoped lang="scss">
.cont_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 80px;
  background: #fff;
  box-shadow: 0px 5px 10px 0px rgba(62,105,116,0.102);
  .goBack{
    margin-left: 15px;
    i{
      font-size: 16px;
    }
  }
  p.title{
    font-size: 14px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .left_logo{ 
    height: 43px;
    width: auto;
    margin-left: 8px;
    img{
      width: auto;
      height: 100%;
    }
  }
  .right_menu{
    margin-right: 12px;
    display: flex;
    align-items: center;
    .login_state{
      height: 36px;
     
      margin-right: 24px;
      display: flex;
      justify-content: center;
      border-radius: 36px;
      padding: 0 10px;
      .text_login{
         background: rgba(0,126,247,0.1);
         padding: 0px 10px;
         height: 100%;
          border-radius: 36px;
        p{
          font-size: 14px;
          color: #007EF7;
        }
      }
      .per_info{
        img{
          width: 30px;
          height: 30px;
          border-radius: 100%;
        }
      }

    }
    p.img_icon{
      img{
        width: 20px;
        height: 20px;
      }
      span{
        font-size: 13px;
        color: #3D3D3D;
      }
    }
    .menu_list{
      position: absolute;
      left: 0;
      top: 80px;
      width: 100%;
      height: auto;
      background: rgba(0,0,0,.95);
      padding: 45px 0;
      z-index: 9999;
      li{
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        a{
          color: #fff;
          font-size: 16px;
        }
      }
    }
    .mask_deep_box{
      position: absolute;
      left: 0;
      top: 80px;
      width: 100%;
      min-height: 100vh;
      background: rgba(0,0,0,.05);
      padding: 45px 0;
      z-index: 999;
    }
  }
}
</style>

